import { HttpHeaders, HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpHelperService } from "src/app/shared/services/http-helper.service";
import { SKIP_LOADING_HEADER } from "src/app/shared/services/loading-interceptor/loading-interceptor.service";

@Injectable({
  providedIn: "root",
})
export class LoginService {
  private readonly httpHelperService = inject(HttpHelperService);

  public getQuestionList(): Observable<any> {
    return this.httpHelperService.get("/login/secretquestions/list");
  }

  public submitFirstTimeLogin(payload): Observable<any> {
    return this.httpHelperService.postWithOptions(
      "/login/profile/save",
      payload,
      {
        baseUrl: this.httpHelperService.resolveAlphaSatBaseUrl(),
      },
    );
  }

  public submitResetPassword(payload): Observable<any> {
    return this.httpHelperService.postWithOptions(
      "/login/password/reset",
      payload,
      {
        baseUrl: this.httpHelperService.resolveAlphaSatBaseUrl(),
      },
    );
  }

  public getLoginAlertMsg(): Observable<any> {
    return this.httpHelperService.getWithOptions(`/alert`, new HttpParams(), {
      headers: new HttpHeaders({ [SKIP_LOADING_HEADER]: "1" }),
    });
  }
  public testExpireSession() {
    return this.httpHelperService.get(`/session/expire`);
  }
}
